<template>
  <div id="app">
    <!-- 
    <nav v-if="!hideNav">
      <router-link to="/">首页</router-link> |
      <router-link to="/ios">iOS</router-link> |
      <router-link to="/android">Android</router-link>
    </nav>
     -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    hideNav() {
      // 在 ITMonth25Summary 页面隐藏导航栏
      return this.$route.path.startsWith('/itmonth25')
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

nav {
  padding: 30px;
  background-color: #f5f5f5;
  margin-bottom: 20px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
  padding: 0 10px;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
